/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取VIP智能切网列表
export function listIccidPriceSwitch(params) {
    return request({
        url: 'iccidPriceSwitch/list.do?',
        method: 'post',
        data: params
    })
}

// 新增/编辑VIP智能切网
export function saveIccidPriceSwitch(params) {
    return request({
        url: 'iccidPriceSwitch/save.do?',
        method: 'post',
        data: params
    })
}

// 根据ID删除VIP智能切网
export function deleteById(params) {
    return request({
        url: 'iccidPriceSwitch/deleteById.do?',
        method: 'post',
        data: params
    })
}

// 批量导入VIP智能切网
export function batchImportSync(params) {
    return request({
        url: 'iccidPriceSwitch/batchImportSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量删除VIP智能切网
export function batchDeleteSync(params) {
    return request({
        url: 'iccidPriceSwitch/batchDeleteSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 获取VIP智能切网订单列表
export function orderList(params) {
    return request({
        url: 'iccidPriceSwitch/orderList.do?',
        method: 'post',
        data: params
    })
}

// VIP智能切网订单退款
export function refundVipSwitchOrder(params) {
    return request({
        url: 'order/agentwechatorder/refundVipSwitchOrder.do?',
        method: 'post',
        data: params
    })
} 